import React, { useContext, useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import AssetListItem from './AssetListItem'
import { TimelineContext } from '../../../../../../contexts/TimelineContext'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'
import { groupProjectAssetsByPhase } from '../../../../../../utils/projectAssetPhases'
import ProjectAssetPhaseGroup from '../../../../../Shared/TimelineParts/ProjectAssetPhaseGroup'

export default observer(function ProjectAssets() {
  const { projectAssets, campaign } = useContext(SharedCampaignContext)
  const { setJumpToDate, campaignScenario, clearJumpToDate } = useContext(TimelineContext)

  const phases = groupProjectAssetsByPhase(projectAssets)

  const placementStartForProjectAsset = useCallback(
    (projectAssetId) => {
      const cspa = campaignScenario?.campaign_scenarios_project_assets?.find(
        (c) => +c.project_asset_id === +projectAssetId,
      )
      return cspa?.start_date || null
    },
    [campaignScenario],
  )

  const handleSelectProjectAsset = useCallback(
    (projectAssetId) => {
      const start = placementStartForProjectAsset(projectAssetId)
      const fallback = campaign?.start_date || null
      const target = start || fallback
      if (!target) return
      clearJumpToDate()
      requestAnimationFrame(() => setJumpToDate({ start_date: target }))
    },
    [placementStartForProjectAsset, campaign?.start_date, setJumpToDate, clearJumpToDate],
  )

  return (
    <div className="mt-5 w-full min-w-0">
      <div className="flex items-center justify-between">
        <h2 className="font-semibold text-base dark:text-white">Project assets</h2>
        <span className="text-rb-lighter-grey dark:text-gray-400">{projectAssets?.length}</span>
      </div>

      <div className="mt-2 min-h-[50px] w-full min-w-0 space-y-1">
        {phases.map((phase) => (
          <ProjectAssetPhaseGroup
            key={phase.id}
            phaseId={phase.id}
            label={phase.label}
            count={phase.assets.length}
          >
            {phase.assets.map((asset) => (
              <AssetListItem
                key={`project-asset-${asset.id}`}
                asset={asset}
                onClick={() => handleSelectProjectAsset(asset.id)}
              />
            ))}
          </ProjectAssetPhaseGroup>
        ))}
      </div>
    </div>
  )
})
